import type { TargetMetricsSnapshot } from '../../targetVisitsStore';
import {
  isPersistedRecord,
  type PersistMigrationDefinition,
} from '../persist-migration';
import {
  mergeLegacyTargetScopeNumberRecords,
  mergeLegacyTargetScopeObjectRecords,
} from '../target-scope-key.migration';

type PersistedTargetVisitsState = {
  visits: Record<string, number>;
  metricsHistory: Record<string, TargetMetricsSnapshot>;
};

export const targetVisitsMigration: PersistMigrationDefinition<PersistedTargetVisitsState> =
  {
    version: 1,
    fallback: () => ({ visits: {}, metricsHistory: {} }),
    steps: [
      {
        version: 1,
        migrate: (state) => ({
          visits: isPersistedRecord(state.visits)
            ? mergeLegacyTargetScopeNumberRecords(
                Object.fromEntries(
                  Object.entries(state.visits).flatMap(([key, value]) =>
                    typeof value === 'number' ? [[key, value]] : [],
                  ),
                ),
              )
            : {},
          metricsHistory: isPersistedRecord(state.metricsHistory)
            ? mergeLegacyTargetScopeObjectRecords(
                Object.fromEntries(
                  Object.entries(state.metricsHistory).flatMap(
                    ([key, value]) =>
                      isPersistedRecord(value)
                        ? [[key, value as TargetMetricsSnapshot]]
                        : [],
                  ),
                ),
              )
            : {},
        }),
      },
    ],
  };
